import { defineStore } from "pinia";
import { ref } from "vue";
import { defaultCalcCostDetailData, } from "@erp/shared/components/ui/Document/CalcCost/const";
import { getEstimateConfirmDetail, } from "@erp/shared/api/generated/wrappers/estimate";
import { defaultCheckBoxItem, } from "@erp/shared/components/ui/Document/VersionCombobox/types";
import { APPROVAL_PHASE } from "@erp/shared/components/ui/Approval/approval-phase.types";
import { getEstimateHistoryVersions, } from "@erp/shared/api/generated/wrappers/estimate";
import { getEstimateHistoryVersionData } from "@erp/shared/api/generated/wrappers/estimate";
export const useDocument = defineStore("estimate-search-useDocument", () => {
    const isDocumentDialogOpen = ref(false);
    const selectedData = ref();
    const basicInfo = ref();
    const laborList = ref([]);
    const bomList = ref([]);
    const writerInfo = ref({
        name: "",
        officePhoneNumber: "",
    });
    const calcData = ref(defaultCalcCostDetailData);
    const versions = ref([]);
    const version = ref(defaultCheckBoxItem);
    const documentMap = ref(new Map());
    const setVersion = async (newVersionValue) => {
        if (newVersionValue < 0) {
            throw new Error("[버전 설정에 실패했습니다] 버전번호: " + newVersionValue);
        }
        const targetVersion = versions.value.find((v) => v.value === newVersionValue) ||
            defaultCheckBoxItem;
        version.value = targetVersion;
        if (documentMap.value.has(newVersionValue)) {
            const data = documentMap.value.get(newVersionValue);
            if (!data)
                return;
            setDocumentData(data);
            return;
        }
        if (!targetVersion.historyId) {
            console.warn("No historyId found for version:", targetVersion);
            return;
        }
        const newVersionData = await getEstimateHistoryVersionData(targetVersion.historyId);
        // 빠른 연속 전환 방어: await 후 현재 버전이 바뀌었으면 스킵
        if (version.value.value !== newVersionValue)
            return;
        documentMap.value.set(newVersionValue, {
            info: newVersionData.info,
            calc: newVersionData.calc,
            labor: newVersionData.labor,
            bom: newVersionData.bom,
        });
        setDocumentData(newVersionData);
    };
    const setDocumentData = (data) => {
        selectedData.value = data;
        basicInfo.value = data.info;
        calcData.value = data.calc;
        writerInfo.value = {
            name: data.info.createrName ?? "",
            officePhoneNumber: data.info.createrPhoneNumber ?? "",
        };
        laborList.value = [...data.labor];
        bomList.value = data.bom?.bomJson ? [...data.bom.bomJson] : [];
    };
    const initDocumentData = () => {
        selectedData.value = undefined;
        basicInfo.value = undefined;
        calcData.value = defaultCalcCostDetailData;
        writerInfo.value = {
            name: "",
            officePhoneNumber: "",
        };
        laborList.value = [];
        bomList.value = [];
        versions.value = [];
        version.value = defaultCheckBoxItem;
        documentMap.value.clear();
    };
    const getDocumentData = async (id) => {
        // 초기화
        initDocumentData();
        // 최신 버전 세팅
        const res = await getEstimateConfirmDetail(id);
        version.value = {
            text: res.info.version
                ? `v${res.info.version} (${res.info.approvalPhase})`
                : "(버전 없음)",
            approvalPhase: res.info.approvalPhase || APPROVAL_PHASE.잘못된승인단계,
            value: res.info.version || 0,
        };
        versions.value.push(version.value);
        documentMap.value.set(version.value.value, {
            info: res.info,
            calc: res.calc,
            labor: res.labor,
            bom: res.bom,
        });
        setDocumentData(res);
        // history 버전들 세팅 (최신 버전 제외)
        const histories = await getEstimateHistoryVersions(res.info.id);
        histories.map((history) => {
            if (Number(history.version) === Number(res.info.version))
                return; // 최신 버전은 이미 세팅했으므로 제외
            versions.value.push({
                historyId: history.id,
                text: history.version
                    ? `v${history.version} (${history.approvalPhase})`
                    : "(버전 없음)",
                approvalPhase: history.approvalPhase || APPROVAL_PHASE.잘못된승인단계,
                value: history.version,
            });
        });
        isDocumentDialogOpen.value = true;
    };
    return {
        isDocumentDialogOpen,
        selectedData,
        basicInfo,
        laborList,
        calcData,
        writerInfo,
        bomList,
        versions,
        version,
        setVersion,
        getDocumentData,
    };
});
